import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';

import { DownloadsService } from './downloads.service';
import { Transfer } from '../transfers/transfer.model';
import { ErrorDialogComponent } from '../shared/error-dialog.component';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {

  error: boolean = false;
  id: string;
  loading: boolean = true;
  transfer: Transfer;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private downloadsService: DownloadsService) { }

  ngOnInit() {
    let snap = this.route.snapshot;
    this.id = snap.params.id;
    this.downloadsService.getDownload(this.id).subscribe(
      (transfer) => {
        this.transfer = transfer;
        this.loading = false
      },
      (error) => {
        console.log("Download error: ", error)
        this.loading = false;
        this.error = true;
        if (error == 403) {
          this.showErrorDialog("You are not authorized to view this delivery")
        } else {
          this.showErrorDialog("Delivery not found")
        }
      }
    )
  }

  showErrorDialog(message) {
    let dialogRef = this.dialog.open(ErrorDialogComponent, {
      height: '240px',
      width: '320px',
      data: {message: message}
    });
    setTimeout(() => dialogRef.close(), 6000);
  }
}



// WEBPACK FOOTER //
// ./src/app/downloads/download.component.ts